import { render, staticRenderFns } from "./AudioPlayBtn.vue?vue&type=template&id=1a5f7648&scoped=true&"
import script from "./AudioPlayBtn.vue?vue&type=script&lang=js&"
export * from "./AudioPlayBtn.vue?vue&type=script&lang=js&"
import style0 from "./AudioPlayBtn.vue?vue&type=style&index=0&id=1a5f7648&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5f7648",
  null
  
)

export default component.exports